import api from "api";
import { UUID } from "crypto";
import { useMutation } from "react-query";

interface UpdateLeadCaptureParams {
  data: {
    enrich_notification: boolean;
  };
  leadCaptureId: UUID;
}

export const updateLeadCapture = async ({
  data,
  leadCaptureId,
}: UpdateLeadCaptureParams) => {
  const response = await api.patch(`/p/lead_capture/${leadCaptureId}`, data);
  return response.data;
};

export const useUpdateLeadCapture = (options?: {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}) => {
  const [mutate, { status, error, isLoading }] = useMutation(
    updateLeadCapture,
    {
      ...options,
    },
  );

  return {
    mutate,
    status,
    error,
    isLoading,
  };
};
